import ProductFactory from '../../product-factory';
import IPBoardCreationParameters from './ip-board-creation-parameters';
import Product from '../../../../model/product/product';
import IPBoard from '../../../../model/product/ip-board/ip-board';
import IPBoardPart from '../../../../model/product/ip-board/ip-board-part';
import ProductPlacement from '../../../../model/product/product-placement';
import IPBoardPlacement from '../../../../model/product/ip-board/ip-board-placement';

export default class IPBoardFactory extends ProductFactory<
  IPBoardCreationParameters
> {
  protected createProductTemplate(
    parameters: IPBoardCreationParameters
  ): Product {
    const toReturn = new IPBoard();
    toReturn.boardPart = new IPBoardPart();
    toReturn.draftDesign = false;
    return toReturn;
  }

  protected createProductPlacement(): ProductPlacement {
    const toReturn = new IPBoardPlacement();
    toReturn.productPlacementType = 'IPBoardPlacement';
    return toReturn;
  }

  getProductCreationParameters(parameters: any): IPBoardCreationParameters {
    return null;
  }
}
